import { Layout, Col, Row, Image } from "antd";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Header from "../../Authorized/Header";
import Skills from "../Skills";
import AccountCard from "./AccountCard";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Helmet } from "react-helmet";
import skillsIcon from "../../../images/skills.svg";

const Profile = (props) => {
  const [isAccount, setIsAccount] = useState(true);
  useEffect(() => {
    if (props.match.url === "/consultant/profile/account") {
      setIsAccount(true);
    } else {
      setIsAccount(false);
    }
  }, [props.match.url]);
  return (
    <Layout>
      <Helmet title="Profile | Unicon"></Helmet>
      <Header />
      <Layout.Content>
        <Col xl={{ span: 20 }} style={{ margin: "auto", marginTop: "2vh" }}>
          <Row justify="space-between">
            <Col
              xl={{ span: 4 }}
              style={{
                background: "#ffffff",
                borderRight: "1px solid #1565d8",
              }}
            >
              <Row
                style={{ padding: "1vh", marginTop: "auto" }}
                justify="start"
                align="middle"
              >
                <NavLink
                  data-testid="profile-account"
                  to="/consultant/profile/account"
                  activeClassName="selected"
                  activeStyle={{
                    color: "#1565d8",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <InfoCircleOutlined style={{ margin: "1vh" }} />
                  My Account
                </NavLink>
              </Row>
              <Row
                style={{ padding: "1vh", marginTop: "auto" }}
                justify="start"
                align="middle"
              >
                <NavLink
                  data-testid="profile-skills"
                  to="/consultant/profile/skills"
                  activeClassName="selected"
                  activeStyle={{
                    color: "#1565d8",
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  <Row align="middle">
                    <Col style={{ marginRight: "1vh" }}>
                      <Image
                        style={{ marginRight: "8vh" }}
                        preview={false}
                        src={skillsIcon}
                        width="24px"
                      />
                    </Col>
                    Skills
                  </Row>
                </NavLink>
              </Row>
            </Col>
            <Col xl={{ span: 20 }}>
              {isAccount ? (
                <Col>
                  <AccountCard />
                </Col>
              ) : (
                <Col>
                  <Skills />
                </Col>
              )}
            </Col>
          </Row>
        </Col>
      </Layout.Content>
    </Layout>
  );
};

export default Profile;
